import { atom } from 'jotai';
import { User } from '@supabase/supabase-js';

export const userAtom = atom<User | null>(null);
export const isLoadingAuthAtom = atom<boolean>(true);
export const authErrorAtom = atom<Error | null>(null);